export default __webpack_public_path__ + "static/II_White_On_Black-0d4cd3bea34d64180cdb1715e94bcf79.png";